import { useLocation } from "react-router-dom";

interface LocationState {
  shouldFocusOnCommentsSection?: boolean;
}

export const useCommentsSectionFocus = () => {
  const location = useLocation<LocationState>();
  const { state } = location;
  const shouldFocusOnCommentsSection = state?.shouldFocusOnCommentsSection;
  const setShouldFocusOnCommentsSection = (shouldFocus: boolean) => {
    location.state.shouldFocusOnCommentsSection = shouldFocus;
  };

  return {
    shouldFocusOnCommentsSection,
    location,
    setShouldFocusOnCommentsSection,
  };
};
